/*
 * File: UIRadioListItem.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Formatting for an item in a list of radio inputs
 */
import React from "react";
import { withStyles, Radio, ListItem, ListItemText } from "@material-ui/core";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

const styles = theme => ({
  checked: {},
  listItemText: {
    fontSize: "1em"
  },
  listItem: {
    paddingLeft: theme.spacing(4)
  }
});

const UIRadioListItem = ({
  parentOnChange,
  name,
  optionId,
  selectedId,
  classes
}) => {
  return (
    <ListItem
      className={classes.listItem}
      divider={false}
      dense
      button
      disableRipple={true}
    >
      <ListItemText
        primaryTypographyProps={{ className: classes.listItemText }}
        primary={name}
      />
      <Radio
        disableRipple
        name={name}
        value={name}
        id={optionId.toString()}
        checked={optionId === selectedId}
        onChange={parentOnChange}
        color="primary"
      />
    </ListItem>
  );
};

UIRadioListItem.propTypes = {
  parentOnChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  optionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(observer(UIRadioListItem));
